import React from "react";
import SwanLogo from "./SwanLogo";
import { ChevronDownIcon } from "lucide-react";
import { SCAN_STATUS } from "../services/constant";

const ResultOverview = ({ imgUrl,buttonText,scanStatus }) => {

  return (
    <div className={`w-full flex items-center justify-between py-3 px-4 bg-white text-gray-900 border border-gray-200 rounded-xl font-medium hover:bg-gray-50 cursor-${scanStatus === SCAN_STATUS.PENDING ? "default":"pointer"}  cursor-pointer transition-colors`}>
      <picture className="relative h-12 w-10 rounded-md overflow-hidden flex-shrink-0 flex items-center justify-center">
        {imgUrl ? (
          <img
            className="w-auto max-h-12 max-w-10 h-auto object-contain"
            src={imgUrl}
            alt="tryon"
          />
        ) : (
          <SwanLogo />
        )}
      </picture>
      <aside className="w-[calc(100%-70px)] px-[10px]">
        <h4 className="text-[16px] font-medium">{buttonText || "Your Look is Ready"}</h4>
        <p className="text-[14px] text-gray-500">Swan</p>
      </aside>

      <div className="opacity-[0.4]">
        <ChevronDownIcon className="w-[20px]" />
      </div>
    </div>
  );
};

export default ResultOverview;
